import { z } from 'zod';
import { ParsedRoomUpgradeSchema } from '@common/features/rates/schemas';

export const StaticRoomSchema = z.object({
  additionalImages: z.array(z.object({ imageUrl: z.string() })).nullable(),
  amenities: z.array(z.string()).nullable(),
  beds: z.object({
    total: z.number(),
    types: z
      .array(z.object({ name: z.string(), quantity: z.number() }))
      .nullable()
      .optional(),
  }),
  description: z.string(),
  imageUrl: z.string().nullable(),
  images: z.array(z.object({ url: z.string().nullable() })),
  maxAdults: z.number().nullable(),
  maxChildren: z.number().nullable(),
  maxOccupancy: z.number().nullable().default(2),
  minAdults: z.number().nullable(),
  minChildren: z.number().nullable(),
  roomId: z.string(),
  title: z.string(),
});

const PriceSchema = z.object({
  amount: z.number(),
  currencyCode: z.string(),
});

export const AvailableRoomSchema = z
  .object({
    displayUrgencyMessaging: z.boolean(),
    id: z.string(),
    pricePerNight: PriceSchema,
    pricePerStay: PriceSchema,
    quantity: z.number(),
    rates: z.array(
      z.object({
        description: z.string().nullable(),
        displayUrgencyMessaging: z.boolean(),
        fromPrice: PriceSchema,
        id: z.string(),
        imageUrl: z.string().nullable(),
        name: z.string(),
        pricesPerNight: z.array(z.number()).nullable(),
        quantity: z.number(),
        roomUpgrade: z
          .object({
            amenities: z.array(z.string()).nullable(),
            description: z.string().nullable(),
            displayUrgencyMessaging: z.boolean(),
            id: z.string(),
            imageUrl: z.string().nullable(),
            maxAdults: z.number().nullable(),
            maxChildren: z.number().nullable(),
            maxOccupancy: z.number().nullable().default(2),
            minAdults: z.number().nullable(),
            minChildren: z.number().nullable(),
            name: z.string(),
            priceDifference: PriceSchema,
            pricePerNight: PriceSchema,
            pricePerStay: PriceSchema,
            quantity: z.number(),
          })
          .nullable(),
        terms: z.string().nullable(),
      })
    ),
  })
  .nullable();

export const RatesSchema = z.array(
  z.object({
    rateId: z.string(),
    rateTitle: z.string(),
    rateDescription: z.string(),
    rateImageUrl: z.string(),
    rateTerms: z.string(),
    pricePerStay: z
      .object({
        amount: z.number(),
        currencyCode: z.string(),
        prefix: z.string(),
        suffix: z.string(),
      })
      .optional(),
    roomUpgrade: ParsedRoomUpgradeSchema.nullable(),
    available: z.number(),
  })
);
